import SearchByLocation from "./SearchByLocation";
import SearchByGps from "./SearchByGps";

// ─────────────────────────────────────────────
// SearchBar
// Renders SearchByLocation or SearchByGps depending on mode.
//
// Props:
// - searchMode: "location" or "gps"
// - onSearch: function called when the user submits a search
// - isLoading: disables the button while a search is in progress
// ─────────────────────────────────────────────

function SearchBar({ searchMode, onSearch, isLoading }) {
  if (searchMode === "gps") {
    return <SearchByGps onSearch={onSearch} isLoading={isLoading} />;
  }

  return <SearchByLocation onSearch={onSearch} isLoading={isLoading} />;
}

export default SearchBar;
